/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize ParametersCreation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './parametersViewEdit';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsParamViewEdit = mapStateToProps;
export const mapDispatchToPropsParamViewEdit = mapDispatchToProps;

export default connect(
  mapStateToPropsParamViewEdit,
  mapDispatchToPropsParamViewEdit
)(View);
